export default "__VITE_ASSET__Nc5gBNvK__";